import { FocusMonitor } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Optional,
  Output,
  Self,
} from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';

import { BaseMatControlComponent } from '../../base-mat-control.component';

@Component({
  selector: 'app-easy-input',
  templateUrl: './easy-input.component.html',
  styleUrls: ['./easy-input.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: EasyInputComponent },
  ],
})
export class EasyInputComponent
  extends BaseMatControlComponent<string>
  implements AfterViewInit
{
  @Input() type: 'text' | 'number' | 'search' | 'password' = 'text';
  @Input() min?: number | string = undefined;
  @Input() max?: number | string = undefined;
  @Input() step?: number | string = undefined;
  @Input() maxDecimals = -1;
  @Input() iconSuffix?: string;
  @Input() autocomplete?: string;
  @Input() iconSuffixClickable?: boolean;
  @Input() iconPrefix?: string;
  @Input() svgPrefix?: string;
  @Input() outerSuffixLabel?: string = undefined;
  @Input() labelInfo?: string = undefined;
  @Input() showRequiredWarningIcon = false;
  @Output() blurEvent = new EventEmitter();
  @Output() clickedSuffixEvent = new EventEmitter();

  constructor(
    @Optional() @Self() public override ngControl: NgControl,
    protected override formBuilder: FormBuilder,
    protected override focusMonitor: FocusMonitor,
    protected override elRef: ElementRef
  ) {
    super(ngControl, formBuilder, focusMonitor, elRef);

    this.controlIdentity = 'easy-input';
    this.controlType = 'input';
  }

  ngAfterViewInit() {
    this.userAriaDescribedBy =
      `${this.id}-required-error ${this.id}-min-error ${this.id}-max-error ` +
      `${this.id}-min-length-error ${this.id}-max-length-error ` +
      `${this.id}-license-number-error ${this.id}-trafik-license-number-error ` +
      `${this.id}-ean-number-error ${this.id}-kn-code-error ${this.id}-not-embeddable-error ` +
      `${this.id}-global-container-id ${this.id}-email-error` +
      `${this.id}-ean-number-duplicate-error ${this.id}-tax-number-error` +
      `${this.id}-phone-number-error ${this.id}-weak-password-error`;
  }

  suffixClicked() {
    if (this.iconSuffixClickable) {
      this.clickedSuffixEvent.emit();
    }
  }

  override onBlur() {
    this.blurEvent.emit();
  }
}
